import { createFileRoute } from "@tanstack/react-router";

import { MongodbViewerPanel } from "@/features/mongodb/mongodb-viewer-panel";

export const Route = createFileRoute("/_authenticated/search/mongodb")({
  component: MongodbViewerRoute,
});

function MongodbViewerRoute() {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <MongodbViewerPanel
        target="search360"
        title="Search360 DocumentDB"
        description="Query Search360 collections (read-only in prod)."
      />
    </div>
  );
}
